import { useMemo, useState } from 'react';
import ChartEngine from '../engine/ChartEngine';
import { markList } from '../marks';
import ChartToolbar from './toolbar/ChartToolbar';
import IndicatorLegend from './toolbar/IndicatorLegend';

const TIMEFRAME_OPTIONS = ['1D', '1W', '1M', '1Y'];
const CHART_TYPE_OPTIONS = markList.map((m) => ({ id: m.id, label: m.label }));

// Split out from chart.jsx so the loading/error/empty early-returns there
// stay simple and this component's own hooks (markId, hoveredBar) only run
// once real data actually exists.
const ChartContent = ({
  containerClass,
  containerStyle,
  responseArray,
  indicatorsData,
  currentSymbol,
  currentTimeFrame,
  currentIndicators,
  indicatorOptions,
  onTimeFrameChange,
  onIndicatorsChange,
  isRefreshing,
}) => {
  const [markId, setMarkId] = useState('line');
  const [hoveredBar, setHoveredBar] = useState(null);

  const normalizedForLegend = useMemo(
    () => (responseArray || []).map((item) => ({ date: new Date(item.start_date) })),
    [responseArray]
  );

  return (
    <div className={containerClass} style={containerStyle}>
      <div className="h-[2px] w-full overflow-hidden bg-transparent">
        {isRefreshing && <div className="h-full w-full bg-gradient-to-r from-violet-500 via-indigo-400 to-blue-500 animate-pulse" />}
      </div>
      <ChartToolbar
        chartTypeOptions={CHART_TYPE_OPTIONS}
        chartType={markId}
        onChartTypeChange={setMarkId}
        timeframeOptions={TIMEFRAME_OPTIONS}
        timeframe={currentTimeFrame}
        onTimeframeChange={onTimeFrameChange}
        indicatorOptions={indicatorOptions}
        selectedIndicators={currentIndicators}
        onIndicatorsChange={onIndicatorsChange}
      />

      {currentIndicators.length > 0 && (
        <div className="px-4 pt-3">
          <IndicatorLegend
            active={currentIndicators}
            onChange={onIndicatorsChange}
            indicatorsData={indicatorsData}
            data={normalizedForLegend}
            hoveredBar={hoveredBar}
          />
        </div>
      )}

      <div className="p-2">
        <ChartEngine
          markId={markId}
          symbol={currentSymbol}
          data={responseArray}
          indicatorsData={indicatorsData}
          selectedIndicators={currentIndicators}
          onHover={setHoveredBar}
        />
      </div>
    </div>
  );
};

export default ChartContent;
